import type { ReactNode } from "react";
import { useCallback } from "react";

import { useDispatch } from "react-redux";

import { showErrorToast, showSuccessToast } from "app/actions/toast_actions";

export const useToasts = () => {
    const dispatch = useDispatch();

    const callSuccessToast = useCallback(
        (message: ReactNode) => {
            dispatch(showSuccessToast(message));
        },
        [dispatch],
    );

    const callErrorToast = useCallback(
        (message: ReactNode) => {
            dispatch(showErrorToast(message));
        },
        [dispatch],
    );

    return {
        showSuccessToast: callSuccessToast,
        showErrorToast: callErrorToast,
    };
};
